import React from "react";
import { FaFacebookF, FaTwitter, FaVimeoV } from "react-icons/fa";
import { Link } from "react-router-dom";

const HomeTwoFooter = () => {
  return (
    <>
      <footer>
        <div className="footer__area grey-bg pt-100">
          <div className="footer__top pb-45">
            <div className="container">
              <div className="row">
                <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                  <div className="footer__widget mb-45">
                    <div className="footer__widget-title mb-30">
                      <div className="logo">
                        <Link to="/">
                          <img src="assets/img/logoV.png" alt="" />
                        </Link>
                      </div>
                    </div>
                    <div className="footer__widget-content">
                      <p className="mb-20">
                        Telecom Sales • Call Center Services • Digital Marketing • Business Tech Solutions
                      </p>
                      <p className="mb-30" style={{ fontSize: "14px", color: "#666" }}>
                        © 2025 Vector Tech Solutions LLC. All Rights Reserved.
                      </p>
                      <div className="footer__social theme-social mb-30">
                        <ul>
                          <li>
                            <a href="#">
                              <i>
                                <FaFacebookF />
                              </i>
                              <i>
                                <FaFacebookF />
                              </i>
                            </a>
                          </li>
                          <li>
                            <a href="#">
                              <i>
                                <FaTwitter />{" "}
                              </i>
                              <i>
                                <FaTwitter />{" "}
                              </i>
                            </a>
                          </li>
                          <li>
                            <a href="#">
                              <i>
                                <FaVimeoV />{" "}
                              </i>
                              <i>
                                <FaVimeoV />{" "}
                              </i>
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-xl-2 col-lg-3 col-md-4 col-sm-6 offset-xl-1">
                  <div className="footer__widget mb-45">
                    <div className="footer__widget-title">
                      <h4>Company</h4>
                    </div>
                    <div className="footer__widget-content">
                      <div className="footer__links">
                        <ul>
                          <li>
                            <a href="#about" onClick={(e) => { e.preventDefault(); const el = document.getElementById('about'); if(el) el.scrollIntoView({ behavior: 'smooth' }); }}>About Us</a>
                          </li>
                          <li>
                            <a href="#services" onClick={(e) => { e.preventDefault(); const el = document.getElementById('services'); if(el) el.scrollIntoView({ behavior: 'smooth' }); }}>Services</a>
                          </li>
                          <li>
                            <Link to="/compliance">Compliance</Link>
                          </li>
                          <li>
                            <Link to="/jobs">Jobs</Link>
                          </li>
                          <li>
                            <Link to="/contact-us">Contact Us</Link>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-xl-2 col-lg-3 col-md-4 col-sm-6 offset-xl-1">
                  <div className="footer__widget mb-45">
                    <div className="footer__widget-title">
                      <h4>Resources</h4>
                    </div>
                    <div className="footer__widget-content">
                      <div className="footer__links">
                        <ul>
                          <li>
                            <a href="mailto:contact@vectortechsol.com">Email Us</a>
                          </li>
                          {/* <li>
                            <a href="mailto:contact@vectortechsol.com">Compliance</a>
                          </li> */}
                          <li>
                            <span>7460 Warren Parkway Suite-100, Frisco TX 75034</span>
                          </li>
                          <li>
                            <a href="tel:+18773007146">+1 (877) 300-7146</a>
                            <span style={{ fontSize: "12px", color: "#666", display: "block" }}>This number is used by Spectrum Business for outbound calls</span>
                          </li>
                          <li>
                            <a href="#">Privacy Policy</a>
                          </li>
                          <li>
                            <a href="#">Terms of Service</a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-xl-3 col-lg-3 col-md-5 col-sm-6">
                  <div className="footer__widget mb-45">
                    <div className="footer__widget-title">
                      <h4>Newsletter</h4>
                    </div>
                    <div className="footer__widget-content">
                      <div className="footer__subscribe">
                        <p className="mb-30">
                          Subscribe to out newsletter today to receive updates
                          on the latest news
                        </p>
                        <div className="footer__subscribe-form p-relative">
                          <form action="#">
                            <input type="email" placeholder="Email Address" />
                            <button type="submit">Subscribe</button>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default HomeTwoFooter;
